import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PrifactRoute } from 'src/app/models/prifact-route';
import { Error } from 'src/app/modules/common/errors/error';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { PermissionService } from '../../../../../services/permission/permission.service';
import { RoutingService } from '../../../../../services/routing-service/routing.service';
import { StudentProfileInfo } from '../../models/student-profile-info';
import { EditProfileService } from '../../services/edit-profile.service';
import { StudentProfileService } from '../../services/student-profile.service';
import { UniqueEmailValidator } from '../../validators/unique-email-validator';
import { UniqueMobileValidator } from '../../validators/unique-mobile-validator';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

import { Observable, Subscription } from 'rxjs';
import { StudentReligions } from '../../models/student-religion';
import { StudentCastes } from '../../models/student-caste';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-student-edit-profile',
  templateUrl: './student-edit-profile.component.html',
  styleUrls: ['./student-edit-profile.component.scss']
})
export class StudentEditProfileComponent extends ComponentBase implements OnInit {

  studentInfo: StudentProfileInfo;
  religions: Array<StudentReligions> = [];
  castes: Array<StudentCastes> = []
  editForm: FormGroup;
  submitted: boolean = false;
  errors: Array<Error> = [];
  public config: PerfectScrollbarConfigInterface = {};

  constructor(private studentProfileService: StudentProfileService,
    private formBuilder: FormBuilder,
    private routingService: RoutingService,
    private permissionService: PermissionService,
    private editProfileService: EditProfileService
   ) {
    super();
  }

  ngOnInit() {
    let subscription = this.studentProfileService.getProfileInfo().subscribe(res => {
      this.studentInfo = res;
      
      this.studentProfileService.getStudentReligions().subscribe(res => {
        this.religions = res;
      });
      if(this.studentInfo.student_info.religion_id)
      this.studentProfileService.getStudentCastes(this.studentInfo.student_info.religion_id).subscribe(res=>{
        this.castes=res;
      })
      else{
        this.studentInfo.student_info.religion_id=0;
        this.studentInfo.student_info.caste_id=0;
      }
      this.initForm();
      this.loadValues();
      this.checkPermissionForForm();
    });
    this.addSubscription(subscription);
  }

  get form() { return this.editForm.controls; }

  initForm() {
    this.editForm = this.formBuilder.group({
      email_address: ['',
        [Validators.required, Validators.email],
        UniqueEmailValidator.createValidator(this.editProfileService, this.studentInfo.student_info.email_address)],
      mobile_number: ['',
        [Validators.required, Validators.pattern('^[0-9]{10}$')],
        UniqueMobileValidator.createValidator(this.editProfileService, this.studentInfo.student_info.mobile_number)],
      land_line_number: ['',
        [Validators.required, Validators.pattern('^[0-9]+$')]],
      permanent_address_one: ['', Validators.required],
      permanent_address_two: ['', Validators.required],
      permanent_city: ['', Validators.required],
      permanent_state: ['', Validators.required],
      permanent_country: ['', Validators.required],
      permanent_zip_code: ['',
        [Validators.required, Validators.pattern('^[0-9]{6}$')]],
      sameAddress: [''],
      local_address_one: ['', Validators.required],
      local_address_two: ['', Validators.required],
      local_city: ['', Validators.required],
      local_state: ['', Validators.required],
      local_zip_code: ['',
        [Validators.required, Validators.pattern('^[0-9]{6}$')]],
      caste_id: [''],
      religion_id: ['']
    });
  }

  loadValues() {
    this.editForm.patchValue(this.studentInfo.student_info);
  }

  checkAddressValue(val: boolean) {
    if (val === true) {
      this.form.local_address_one.setValue(this.form.permanent_address_one.value);
      this.form.local_address_two.setValue(this.form.permanent_address_two.value);
      this.form.local_city.setValue(this.form.permanent_city.value);
      this.form.local_state.setValue(this.form.permanent_state.value);
      this.form.local_zip_code.setValue(this.form.permanent_zip_code.value);
    }
    else {
      this.form.local_address_one.setValue('');
      this.form.local_address_two.setValue('');
      this.form.local_city.setValue('');
      this.form.local_state.setValue('');
      this.form.local_zip_code.setValue('');
    }
  }

  checkPermissionForForm() {
    this.permissionService.getPermissionsForUser()
      .subscribe((res) => {
        if( res.permissions.indexOf("Can_Edit_Wards_Profile") == -1){
          this.editForm.disable();
        }
        else{
          this.editForm.enable();          
        }
        if(res.permissions.indexOf("Can_Edit_Email_And_MobileNumber") == -1){
          this.editForm.controls.email_address.disable();
          this.editForm.controls.mobile_number.disable();
        }
        else{
          this.editForm.controls.email_address.enable();
          this.editForm.controls.mobile_number.enable();
        }      
        if(res.permissions.indexOf("Can_Edit_Religion_And_Caste") == -1){
          this.editForm.controls.religion_id.disable();
          this.editForm.controls.caste_id.disable();
        }
        else{
          this.editForm.controls.religion_id.enable();
          this.editForm.controls.caste_id.enable();
        }        
      });
  }
  onReligionChange(e) {
    if (e.target.value) {
      this.castes=[];
      this.form.caste_id.setValue(0);
      // Call getStudentCastes with the selected religion ID
      this.studentProfileService.getStudentCastes(e.target.value).subscribe(res => {
        this.castes = res;
      });
    }
  }
  onSubmit() {
    this.submitted = true;
    if (this.editForm.invalid) {
      return;
    }
    let editedStudentProfile = new StudentProfileInfo();
    editedStudentProfile = this.studentInfo;
    Object.assign(editedStudentProfile.student_info, this.editForm.value);
    if(editedStudentProfile.student_info.religion_id==0) editedStudentProfile.student_info.religion_id=null;
    if(editedStudentProfile.student_info.caste_id==0) editedStudentProfile.student_info.caste_id=null;
    this.studentProfileService.editStudentProfile(editedStudentProfile).subscribe(res => {
      this.onCancel();
    }, err => {
      this.errors = err.error;
    });
  }

  onCancel() {
    let route = new PrifactRoute();
    route.primary_command = ['pages', 'my-account', 'student'];
    route.append_current_url_to_history = true;
    this.studentProfileService.getProfileInfo(true)
    this.routingService.navigate(route);
  };
}
